import React from 'react';
import { NumberField, TextField, SelectField, AreaField } from 'ui-toolkit';
import { stateFilterOptions } from 'utilities/shared/stateFilterOptions';
import { StatesLabelValue } from '../../../../../../ui-toolkit/enums/states';
import { HoldbackContainer } from '../holdbacks/HoldbackContainer';
import { TrackingNumber } from './TrackingNumber';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';
import { ErrorBoundaryConstellation } from '../../../../../../constellationExtended/ErrorBoundary/ErrorBoundaryConstellation';
import { IssuanceDate } from './formFields/IssuanceDate';
import { CheckCategorySelect } from './formFields/CheckCategorySelect';

interface CheckFormFieldsProps {
  data: ICheckDisbursementFormData;
  isReadOnly: boolean;
  TypeChange: React.ReactNode;
  isCheckPrinted: boolean;
  hasIssuanceDateEditPermissions: boolean;
  isCardCollapsed: boolean;
  isDirty: boolean;
}

export const CheckFormFields: React.FC<CheckFormFieldsProps> = ({
  data,
  isReadOnly,
  TypeChange,
  isCheckPrinted,
  hasIssuanceDateEditPermissions,
  isCardCollapsed,
  isDirty,
}) => {
  return (
    <ErrorBoundaryConstellation>
      <div className={'my-4 flex basis-full flex-wrap gap-y-2'}>
        <NumberField
          className={'basis-1/3 pr-2'}
          name={`value.amountCents`}
          isRequired
          label={'Amount'}
          valueIsCents
          mode="currency"
          readOnly={isReadOnly}
        />
        <CheckCategorySelect isCheckPrinted={isCheckPrinted} isReadOnly={isReadOnly} />
        {TypeChange}
        <TextField
          className={'basis-2/3 pr-2'}
          name={`value.name`}
          isRequired
          label={'Beneficiary Name'}
          readOnly={isReadOnly}
        />
        <IssuanceDate
          hasIssuanceDateEditPermissions={hasIssuanceDateEditPermissions}
          isCheckPrinted={isCheckPrinted}
          isReadOnly={isReadOnly}
        />
        <HoldbackContainer id={data.id} isReadOnly={isReadOnly} isDirty={isDirty} />
        {!isCardCollapsed && (
          <>
            <TextField
              className={'basis-3/4 pr-2'}
              name={`value.mailingAddress.streetAddress`}
              label="Street Address"
              placeholder="155 W 12th Street"
              readOnly={isReadOnly}
              isRequired
            />
            <TextField
              className={'basis-1/4'}
              name={`value.mailingAddress.unit`}
              label="Unit"
              placeholder="4b"
              readOnly={isReadOnly}
            />
            <TextField
              className={'basis-1/2 pr-2'}
              name={`value.mailingAddress.city`}
              label="City"
              placeholder="City"
              readOnly={isReadOnly}
              isRequired
            />
            <SelectField
              className={'basis-1/4 pr-2'}
              name={`value.mailingAddress.stateAbbreviation`}
              filterOption={stateFilterOptions}
              options={StatesLabelValue}
              label={`State`}
              placeholder={`Select one...`}
              isDisabled={isReadOnly}
              isRequired
            />
            <TextField
              className={'basis-1/4 pr-2'}
              name={`value.mailingAddress.zipCode`}
              label="Zip"
              placeholder="99999"
              readOnly={isReadOnly}
              isRequired
            />
            <AreaField
              className={'basis-full'}
              name={`value.memo`}
              label="Memo"
              placeholder="Memo"
              readOnly={isReadOnly}
            />
            <TrackingNumber />
          </>
        )}
      </div>
    </ErrorBoundaryConstellation>
  );
};
